import React from "react";
import DefaultButton from '../../../components/DefaultButton'
import { useModal } from "../../../contexts/ModalContext";

export default function HumanBanner({data}) {
  const {openQueryModal} = useModal();
  return (
    <>
      <section className="human-resources-bannner header-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <h1 className="heading">{data?.head}</h1>
              <p>{data?.desc}</p>
              <DefaultButton to={data?.slug} onClick={openQueryModal} text={data?.btn} color />
            </div>
          </div>
        </div>

        <img src={data?.img} alt="Human Resourse Right Image" />
      </section>
    </>
  )
}